import { render, staticRenderFns } from "./JsonFormString.vue?vue&type=template&id=5bab5bc0&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./JsonFormString.vue?vue&type=script&lang=ts"
export * from "./JsonFormString.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bab5bc0",
  null
  
)

export default component.exports